import React, { Component } from 'react';
import { connect } from 'react-redux';
import L from 'leaflet';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import Dropdown from 'react-multiselect-checkboxes/lib/Dropdown';
import { Map, CircleMarker, ScaleControl, LayerGroup } from 'react-leaflet';
import { GoogleLayer } from 'react-leaflet-google';
import { MapConstants } from './constants';
import { googleMapsApiKey } from '../../config';
import MapListingMarker from './map-listing-marker';
import { MAGIC_NUMBER } from '../../constants/magicNumbers';

let isMobileFullScreen = false;
const MOBILE_FULL_SCREEN_BUTTON = "mobile-fullscreen-button"

const foodIcon = L.icon(MapConstants.foodIcon);
const campusIcon = L.icon(MapConstants.campusIcon);
const attractionIcon = L.icon(MapConstants.attractionIcon);

const FILTER_COLORS = {
  food: "red",
  campus: "blue",
  attraction: "#00aa99"
}

const FilterModal = ({ handleClose, show, children, title, color }) => {
  const showHide = show ? 'modal display-block' : 'modal display-none';
  return (
    <div className={showHide}>
      <section className="modal-main">
        <div className={`row ${color}`}> {/* ` For Chrome Debugging */}
          <span>{title}</span>
          <i onClick={handleClose} className="fas fa-times ml-auto"></i>
        </div>
        {children}
        <div className="row">
          <button type="button" onClick={handleClose}>Apply</button>
        </div>
      </section>
    </div>
  );
};

const FoodFilterButton = (props) => {
  return (
    <div className={`col ${isMobileFullScreen === true ? MOBILE_FULL_SCREEN_BUTTON : ""}`} onClick={props.onPress}> {/* ` For Chrome debugging*/}
      <div className={`filter-tab food local-attraction`} id="destination-food"> {/* ` For Chrome debugging*/}
        <div className="primary-filter">Food & Drink<p className="category-title">({props.children})</p></div>
      </div>
    </div>
  )
}

const CampusFilterButton = (props) => {
  return (
    <div className={`col ${isMobileFullScreen === true ? MOBILE_FULL_SCREEN_BUTTON : ""}`} onClick={props.onPress}> {/* ` For Chrome debugging*/}
      <div className={`filter-tab campus local-attraction`} id="destination-campus"> {/* ` For Chrome debugging*/}
        <div className="primary-filter">Campus-Related<p className="category-title">({props.children})</p></div>
      </div>
    </div>
  )
}

const AttractionsFilterButton = (props) => {
  return (
    <div className={`col ${isMobileFullScreen === true ? MOBILE_FULL_SCREEN_BUTTON : ""}`} onClick={props.onPress}> {/* ` For Chrome debugging*/}
      <div className={`filter-tab attractions local-attraction`} id="destination-attraction"> {/* ` For Chrome debugging*/}
        <div className="primary-filter">Local Attractions<p className="category-title">({props.children})</p></div>
      </div>
    </div>
  )
}

const defaultMarker = L.divIcon(MapConstants.defaultMarker);
const activeMarker = L.divIcon(MapConstants.activeMarker);
const mapStateToProps = state => ({
  search: state.Search
});

const CustomDropdown = (props) => {
  return (
    <div className='local-attraction-dropdown'>
      <Dropdown {...props} className="menu-dropdown" />
    </div>
  )
}

class AttractionsMapComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      points: [],
      showFoodModal: false,
      showCampusModal: false,
      showAttractionsModal: false,
      pointsLayers: [],
      mobileFullscreen: false,
      width: window.innerWidth,
      isRetrievingPoints: false
    }
    this.getCenter = this.getCenter.bind(this);
    this.map = React.createRef();
    this.defaultLayers = [];
    this.onMultiSelectChanged = this.onMultiSelectChanged.bind(this);
    this.setIsRetrievingPoints = this.setIsRetrievingPoints.bind(this);
    this.isMultiSelectOptionDisabled = this.isMultiSelectOptionDisabled.bind(this);
  }

  getCenter = () => {
    return !!this.props.center ? this.props.center : MAGIC_NUMBER.US_CENTER
  }

  setIsRetrievingPoints = (retrieving) => {
    this.setState({
      isRetrievingPoints: retrieving
    })
  }

  isMultiSelectOptionDisabled = option => {
    return this.state.isRetrievingPoints;
  }

  checkState(childFilter) {
    let { points } = this.state;

    let secondaryFilterArray = points.filter(x => x.secondaryFilter === childFilter);
    if (secondaryFilterArray.length === 0) return true;
    let newPoints = points.filter(x => x.secondaryFilter !== childFilter).slice(0);
    this.setState({ points: newPoints });
    return false;
  }

  getPlaces = (parentFilter, keyword) => {
    if (this.checkState(keyword)) {
      let setPointsFunc = this.setPoints;
      let setIsRetrievingPoints = this.setIsRetrievingPoints;
      const center = this.getCenter();
      let service = new google.maps.places.PlacesService(document.getElementById('places-results'));
      let request = {
        keyword: keyword,
        location: new google.maps.LatLng(center[0], center[1]),
        radius: this.props.attractionsRadius ? this.props.attractionsRadius : 16094
      }

      setIsRetrievingPoints(true);

      service.nearbySearch(request, function (results, status) {

        if (status === google.maps.places.PlacesServiceStatus.OK) {
          setPointsFunc(parentFilter, keyword, results);
        } else {
          setPointsFunc(parentFilter, keyword, []);
        }

        setIsRetrievingPoints(false);
      });
    }
  }

  renderPopup(r, linkColor) {
    return (
      "<div>" +
      "<strong>" + r.name + "</strong>" +
      "<div>" + r.vicinity + "</div>" +
      `<a style="color: ${linkColor} !important;" href='https://www.google.com/maps/search/?api=1&query=` + r.name +
      "&query_place_id=" + r.place_id + "' target='_blank'>View on Google Maps</a>" +
      "</div>"
    )
  }

  // setDefaultLayers = () => {
  //     let defaultLayers = this.defaultLayers;
  //     this.map.current.leafletElement.eachLayer(function(layer) {
  //         defaultLayers.push(layer);
  //     });
  // }

  setPoints = (parentFilter, name, results) => {
    let obj = {
      primaryFilter: parentFilter,
      secondaryFilter: name,
      markers: []
    };

    results.map(x => {
      let popup = L.popup();

      let icon;
      let filterColor;
      switch (parentFilter) {
        case 'food':
          icon = foodIcon;
          filterColor = FILTER_COLORS.food;
          break;
        case 'campus':
          icon = campusIcon;
          filterColor = FILTER_COLORS.campus;
          break;
        default:
          icon = attractionIcon;
          filterColor = FILTER_COLORS.attraction;
          break;
      }

      popup.setContent(this.renderPopup(x, filterColor));

      let marker = L.marker([x.geometry.location.lat(), x.geometry.location.lng()], {
        icon: icon
      }).bindPopup(popup);
      obj.markers.push(marker);
    });

    let objArray = this.state.points.slice(0);
    objArray.push(obj);
    this.setState({ points: objArray });
  }

  toggleFoodModal = () => {
    this.setState({ showFoodModal: !this.state.showFoodModal })
  }

  toggleCampusModal = () => {
    this.setState({ showCampusModal: !this.state.showCampusModal })
  }

  toggleAttractionsModal = () => {
    this.setState({ showAttractionsModal: !this.state.showAttractionsModal })
  }

  // componentDidMount() {
  //     //If the map is already loaded, lets get the default layers
  //     setTimeout(() => {
  //         if(this.map && this.map.current && this.defaultLayers.length == 0) {
  //             this.setDefaultLayers();
  //         }
  //     }, 500);
  // }

  markPoints(points) {
    if (!points.length)
      return;
    let foodLayer = L.layerGroup([]);
    let campusLayer = L.layerGroup([]);
    let attractionsLayer = L.layerGroup([]);

    points.map(group => {
      let childLayer = L.layerGroup(group.markers);
      switch (group.primaryFilter) {
        case 'food':
          foodLayer.addLayer(childLayer);
          break;
        case 'campus':
          campusLayer.addLayer(childLayer);
          break;
        case 'attractions':
          attractionsLayer.addLayer(childLayer);
          break;
        default:
          break;
      }
    });
    if (foodLayer.getLayers().length > 0) foodLayer.addTo(this.map.current.leafletElement);
    if (campusLayer.getLayers().length > 0) campusLayer.addTo(this.map.current.leafletElement);
    if (attractionsLayer.getLayers().length > 0) attractionsLayer.addTo(this.map.current.leafletElement);
    this.setState({ pointsLayers: [foodLayer, campusLayer, attractionsLayer] });
  }

  componentDidUpdatePart(prevState, map) {
    let { points, pointsLayers } = this.state;

    if (prevState.points !== points) {
      if (map) {
        map.current.leafletElement.eachLayer(function (layer) {
          if (pointsLayers.length > 0 && pointsLayers.includes(layer)) {
            map.current.leafletElement.removeLayer(layer);
          }
        });
      }

      this.markPoints(points);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let map = this.map;

    this.componentDidUpdatePart(prevState, map);

    let { hoveredListing, mapMobile } = this.props.search;
    map.current.leafletElement.eachLayer(function (layer) {

      if (layer.options.id && layer.setIcon) {
        if (layer.options.id === hoveredListing) {
          layer.setIcon(activeMarker);
          layer.setZIndexOffset(100);
        } else {
          layer.setIcon(defaultMarker);
          layer.setZIndexOffset(0);
        }
      }
    });

    if (mapMobile)
      map.current.leafletElement.invalidateSize();
  }

  componentDidMount() {
    if (this.props.fullscreen) {
      this.enterFullScreen();
    }
  }

  enterFullScreen = () => {
    let isMobile = this.state.width <= 576;
    if (isMobile) {
      isMobileFullScreen = true;
      this.setState({ mobileFullscreen: true }, () => {
        let map = document.getElementsByClassName('leaflet-container');
        for (var i = 0; i < map.length; i++) {
          map.item(i).classList.add('mobile-fullscreen-child');
        }
      });
    }

  }

  exitFullScreen = () => {
    let isMobile = this.state.width <= 576;
    if (isMobile) {
      isMobileFullScreen = false;
      this.setState({ mobileFullscreen: false }, () => {
        let map = document.getElementsByClassName('leaflet-container');
        for (var i = 0; i < map.length; i++) {
          map.item(i).classList.remove('mobile-fullscreen-child');
        }
      });
    }
  }

  onMultiSelectChanged = (selections, event, filterType) => {
    this.getPlaces(filterType, event.option.value)
  }

  onMapFilterMap = (x, i, filterName) => {
    return (
      <div className="filter" key={i}>
        <label htmlFor={x.searchTerm}>
          <input type="checkbox" name={filterName}
            disabled={this.state.isRetrievingPoints}
            onClick={() => this.getPlaces(filterName, x.searchTerm)}
            id={x.searchTerm} value={x.searchTerm} /> {x.displayName}
        </label>
      </div>
    )
  }

  onMapDropdownMap = x => {
    return {
      label: x.displayName,
      value: x.searchTerm
    }
  }

  render() {
    const { underLocalAttrations } = this.props;

    let foodFilterCSS = '';
    if (this.state.points.filter(x => x.primaryFilter === 'food').length > 0)
      foodFilterCSS = 'active';

    let campusFilterCSS = '';
    if (this.state.points.filter(x => x.primaryFilter === 'campus').length > 0)
      campusFilterCSS = 'active';

    let attractionsFilterCSS = '';
    if (this.state.points.filter(x => x.primaryFilter === 'attractions').length > 0)
      attractionsFilterCSS = 'active';

    let filterCSSAppend = '';
    let filterRowCSSAppend = '';

    if (underLocalAttrations) {
      filterCSSAppend = 'local-attraction';
      filterRowCSSAppend = 'local-attraction-row'
    }

    let mapParentClassName = '';
    let colAppend = '';
    if (this.state.mobileFullscreen === true) {
      mapParentClassName = "mobile-fullscreen-parent";
      colAppend = MOBILE_FULL_SCREEN_BUTTON;
    }

    const center = this.getCenter();
    let bounds = null;

    if (this.props.listings && this.props.listings.length > 0) {
      let first = this.props.listings[0].geometry.coordinates.slice().reverse();
      bounds = L.latLngBounds(first);
      this.props.listings.map(l => {
        bounds.extend(l.geometry.coordinates.slice().reverse());
      });

      let ne = bounds.getNorthEast();
      let sw = bounds.getSouthWest();
      let neSymetric = [ne.lat + (center[0] - ne.lat) * 2, ne.lng + (center[1] - ne.lng) * 2];
      let swSymetric = [sw.lat + (center[0] - sw.lat) * 2, sw.lng + (center[1] - sw.lng) * 2];
      bounds.extend([swSymetric, neSymetric]);
    }

    return (
      <div id="map-parent" className={mapParentClassName}> {/* ` For Chrome debugging*/}
        {this.state.mobileFullscreen === false ? null : <div>
          <button className="mobile-fullscreen-close" onClick={() => this.exitFullScreen()}>
            <span>
              <svg fill="white" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 512 512">
                <path d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4 L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1 c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1 c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"></path>
              </svg>
            </span>
          </button>
          <a />
        </div>}
        <Map center={this.getCenter()} zoom={this.props.zoom} maxZoom="16" ref={this.map} bounds={bounds}
          dragging={!L.Browser.mobile || this.state.mobileFullscreen} onClick={() => this.enterFullScreen()}>
          <GoogleLayer googlekey={googleMapsApiKey} maptype="road" libraries={['places']} styles={MapConstants.styles} onAfterLoad={this.setDefaultLayers} />
          <LayerGroup id="listings">
            {this.props.listings && this.props.listings.map(l => {
              if (this.props.circle) return (<CircleMarker key={l._id} center={[l.geometry.coordinates[1], l.geometry.coordinates[0]]} radius="50" />)
              else return (<MapListingMarker key={l._id} listing={l} dates={this.props.dates} onMarkerClick={this.props.popupOpen} onPopupClose={this.props.popupClose} />)
            })}
          </LayerGroup>
          <ScaleControl position="topright" />
        </Map>
        {
          !underLocalAttrations ?
            <div className={`row ${filterRowCSSAppend}`}>
              <div className={`col ${colAppend}`}> {/* ` For Chrome debugging*/}
                <div onClick={this.toggleFoodModal}
                  className={`filter-tab food ${foodFilterCSS} ${filterCSSAppend}`}> {/* ` For Chrome debugging*/}
                  <div className="primary-filter">Food & Drink</div>
                </div>
              </div>
              <div className={`col ${colAppend}`}> {/* ` For Chrome debugging*/}
                <div onClick={this.toggleCampusModal}
                  className={`filter-tab campus ${campusFilterCSS} ${filterCSSAppend}`}> {/* ` For Chrome debugging*/}
                  <div className="primary-filter">Campus-Related</div>
                </div>
              </div>
              <div className={`col ${colAppend}`}> {/* ` For Chrome debugging*/}
                <div onClick={this.toggleAttractionsModal}
                  className={`filter-tab attractions ${attractionsFilterCSS} ${filterCSSAppend}`}> {/* ` For Chrome debugging*/}
                  <div className="primary-filter">Local Attractions</div>
                </div>
              </div>
            </div> : null
        }
        {
          !underLocalAttrations ?
            <div>
              <FilterModal show={this.state.showFoodModal} handleClose={this.toggleFoodModal} title="Food & Drink" color="red">
                {MapConstants.foodFilters.map((x, i) => this.onMapFilterMap(x, i, 'food'))}
              </FilterModal>
              <FilterModal show={this.state.showCampusModal} handleClose={this.toggleCampusModal} title="Campus-Related" color="blue">
                {MapConstants.campusFilters.map((x, i) => this.onMapFilterMap(x, i, 'campus'))}
              </FilterModal>
              <FilterModal show={this.state.showAttractionsModal} handleClose={this.toggleAttractionsModal} title="Local Attractions" color='cyan'>
                {MapConstants.attractionFilters.map((x, i) => this.onMapFilterMap(x, i, 'attractions'))}
              </FilterModal>
            </div> :
            <div className={`row ${filterRowCSSAppend}`}>
              <ReactMultiSelectCheckboxes
                options={MapConstants.foodFilters.map(this.onMapDropdownMap)}
                hideSearch
                components={{
                  DropdownButton: FoodFilterButton,
                  Dropdown: CustomDropdown
                }}
                isOptionDisabled={this.isMultiSelectOptionDisabled}
                placeholderButtonLabel="Select Sub-Categories"
                onChange={(options, event) => this.onMultiSelectChanged(options, event, "food")}
              />
              <ReactMultiSelectCheckboxes
                options={MapConstants.campusFilters.map(this.onMapDropdownMap)}
                hideSearch
                placeholderButtonLabel="Select Sub-Categories"
                onChange={(options, event) => this.onMultiSelectChanged(options, event, "campus")}
                isOptionDisabled={this.isMultiSelectOptionDisabled}
                components={{
                  DropdownButton: CampusFilterButton,
                  Dropdown: CustomDropdown
                }}
              />
              <ReactMultiSelectCheckboxes
                options={MapConstants.attractionFilters.map(this.onMapDropdownMap)}
                hideSearch
                onChange={(options, event) => this.onMultiSelectChanged(options, event, "attractions")}
                placeholderButtonLabel="Select Sub-Categories"
                isOptionDisabled={this.isMultiSelectOptionDisabled}
                components={{
                  DropdownButton: AttractionsFilterButton,
                  Dropdown: CustomDropdown
                }}
              />
            </div>
        }
      </div>
    );
  }
}

export default connect(mapStateToProps)(AttractionsMapComponent);
